import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CurrentFlights } from '../../../../core/services/dataBean/EntityCatalog';
import usePaginator from '../../../theme/Component/usePaginator';
import { BasicPage } from '../../../theme/Component/BasicPage';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { BasicTable } from '../../../theme/Component/BasicTable';
type propsForm = {
    CallSign: string;
}

export const CurrentFlights = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_CurrentFlights)
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<propsForm>>({});

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const formatDateTime = (date?: string, timezone?: string) => {
        if (!date) return "NA";

        return new Date(date).toLocaleString('es-CO', {
            timeZone: timezone || 'UTC',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const renderTravel = (jsonArrival: string, jsonDeparture: string) => {
        const arrival = JSON.parse(jsonArrival || "{}");
        const departure = JSON.parse(jsonDeparture || "{}");

        if (Object.keys(arrival).length === 0 || Object.keys(departure).length === 0) {
            return `<small>NA</small>`;
        }

        return `
        <div class="small">

            <!-- Línea principal -->
            <div class="d-flex justify-content-between align-items-center">

                <!-- Ruta -->
                <div>
                    <strong>${departure.iata || "---"}</strong>
                    <span class="mx-1">→</span>
                    <strong>${arrival.iata || "---"}</strong>
                </div>

                <!-- Estado -->
                <div>
                    ${arrival.delay
                ? `<span class="badge bg-danger">Retrasado: +${arrival.delay} min</span>`
                : `<span class="badge bg-success">A Tiempo</span>`
            }
                </div>
            </div>

            <!-- Aeropuertos -->
            <div class="text-muted text-truncate">
                ${departure.airport || "NA"} → ${arrival.airport || "NA"}
            </div>

            <!-- Horarios -->
            <div class="text-muted">
                ${formatDateTime(departure.scheduled, departure.timezone)} 
                <span class="mx-1">→</span> 
                ${formatDateTime(arrival.scheduled, arrival.timezone)}
            </div>

        </div>
    `;
    };

    const getLista = () => {

        const props: any = {}

        if (form.CallSign) props.CallSign = form.CallSign

        instance.getCurrentFlights(paginador.page, 15, props).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    resp.List.forEach(element => {
                        const data = element.DataBeanProperties;

                        data.TravelProps = renderTravel(data.Arrival, data.Departure);
                    });
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDFlightItem', visible: true },
        { title: 'Nombre', property: 'Iata', visible: true },
        { title: 'Vuelo', property: 'Icao', visible: true },
        { title: 'Programa', property: 'TravelProps', visible: true },
    ]

    return (
        <BasicPage titulo='Vuelos Disponibles' >
            <div className="row">
                <div className="col-md-6">
                    <label>Numero de Vuelo</label>
                    <input type="text" className="form-control" value={form.CallSign} onChange={(e) => { setForm({ ...form, CallSign: e.target.value }) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable head={head} body={lista} rowSet={setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                </div>
            </div>
        </BasicPage>
    )
}